import axios from '@/shared/utils/axios-init';

/* eslint-disable */
const initialState = {
  unauthorizedDialog: false,

  // TODO: doesn't use 
  //----------------------
  successfulSnackbar: {
    state: false,
    msg: '',
  },
  
  successfulDialogState: false,
  successfulDialogMessage: '',
  baseCurrToUsdRate: '',
  quoteCurrToUsdRate: '',

  rates: {
    sellRate: null,
    buyRate: null,
    marketBuyRate: null,
    marketSellRate: null,
  },
  preventBuyDeal: false,
  preventSellDeal: false,
};

const getters = {
  unauthorizedDialogState: state => state.unauthorizedDialog,

  successfulSnackbarState: state => state.successfulSnackbar,
  getSuccessfulDialogState: state => state.successfulDialogState,
  getSuccessfulDialogMessage: state => state.successfulDialogMessage,
  getBaseCurrToUsdRate: state => state.baseCurrToUsdRate,
  getQuoteCurrToUsdRate: state => state.quoteCurrToUsdRate,
  getRates: state => state.rates,

  getPreventBuyState: state => state.preventBuyDeal,
  getPreventSellState: state => state.preventSellDeal,
  getMarketBuyFee: state => state.marketBuyFee,
  getMarketSellFee: state => state.marketSellFee,
};

const mutations = {
  toggleUnauthorizedDialog(state, data) {
    state.unauthorizedDialog = data;
  },

  toggleSuccessfulSnackbar(state, data) {
    state.successfulSnackbar.state = data.state;
    state.successfulSnackbar.msg = data.msg;
  },
  toggleSuccessfulDialog(state, data) {
    state.successfulDialogState = data.state;
    state.successfulDialogMessage = data.msg;
  },
  setBaseCurrToUsdRate(state, data) {
    state.baseCurrToUsdRate = data;
  },
  setQuoteCurrToUsdRate(state, data) {
    state.quoteCurrToUsdRate = data;
  },

  setRates(state, rates) {
    state.rates.buyRate = rates.buy_rate;
    state.rates.sellRate = rates.sell_rate;
    state.rates.marketBuyRate = rates.market_buy_rate;
    state.rates.marketSellRate = rates.market_sell_rate;
  },

  setSellRate(state, data) {
    state.rates.sellRate = data;
  },

  setMarketBuyRate(state, data) {
    state.rates.marketBuyRate = data;
  },

  setMarketSellRate(state, data) {
    state.rates.marketSellRate = data;
  },

  preventDeal(state, data) {
    if (data.type === 'buy') {
      state.preventBuyDeal = data.state;
    } else {
      state.preventSellDeal = data.state;
    }
  },
};

const actions = {
  successfulSnackbar({ commit }, data) {
    commit('toggleSuccessfulSnackbar', data);
  },
  successfulDialog({ commit }, data) {
    commit('toggleSuccessfulDialog', data);
  },
  async fetchCalculatorData({ commit, dispatch, rootState }, couple) {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const data = await axios.post('/couple-info', couple, { headers: { Authorization: `Bearer ${token}` } } );

      const calculatorData = data.data;
      commit('dashboard/orders/setFee', +calculatorData.commission, { root: true });
      commit('dashboard/orders/setMarketSellFee', calculatorData.commission_market_price, { root: true });
      commit('dashboard/orders/setMarketBuyFee', calculatorData.commission_market_buy, { root: true });
      

      const baseCurrencyToUsd = calculatorData.usd_rates[rootState.dashboard.market.currenciesPair.baseCurrency];
      const quoteCurrencyToUsd = calculatorData.usd_rates[rootState.dashboard.market.currenciesPair.quoteCurrency];
      commit('setBaseCurrToUsdRate', +baseCurrencyToUsd);
      commit('setQuoteCurrToUsdRate', +quoteCurrencyToUsd);
      
      // set Rates
      commit('setRates', calculatorData.rates);

      return data;
    } catch (error) {
      if (error.response.status === 500) {
        console.error(`Error: ${error.response.status}, ${error.response.statusText}`);
        return error.response;
      }
  
      const defaultPairs = {
        baseCurrency: 'BTC',
        baseCurrencyTitle: 'Bitcoin',
        quoteCurrency: 'USDT',
        quoteCurrencyTitle: 'Tether',
        isCrypt: 0,
      }   
      // Couple doesn't exist, reset to default and load data
      localStorage.setItem('currencies', JSON.stringify(defaultPairs));
      commit('dashboard/market/setCurrenciesPair', defaultPairs, { root: true });

      await dispatch('dashboard/calculator/fetchCalculatorData', {
        base: defaultPairs.baseCurrency,
        quoted: defaultPairs.quoteCurrency,
      }, { root: true });

      return error.response;
    }
  },
};


export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/modules/Dashboard/modules/calculator.js